import { gsap } from "gsap/all";
import { ScrollTrigger, SplitText, ScrollSmoother, DrawSVGPlugin, MotionPathPlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, DrawSVGPlugin, MotionPathPlugin);

import { CountUp } from "../components/CountUp.js";
import { sliderMobile } from "../components/sliders.js";
import { BurgerMenu } from "../components/burgerMenu";

// -------------------------------
// FONCTIONS D'ANIMATIONS
// -------------------------------
const introAnimations = () => {
	const elts_intro = gsap.utils.toArray('[data-gsap="animate-elt-intro"]');
	elts_intro.forEach((elt, index) => {
		gsap.from(elt, {
			y: 100 + index * 10,
			rotate: 2,
			alpha: 0,
			ease: "linear",
			duration: 1,
			scrollTrigger: {
				trigger: elt.closest("section"),
				start: "top 50%",
				toggleActions: "play none none reverse",
			},
		});
	});

	const gridHeading = document.querySelector(".nav-grid__heading");
	gsap.to(gridHeading, {
		alpha: 1,
	});

	const splitheading = new SplitText(gridHeading, {
		type: "chars,words,lines",
		linesClass: "line",
		charsClass: "char",
		mask: "lines",
	});

	splitheading.lines.forEach((line, i) => {
		gsap.from(line.querySelectorAll(".char"), {
			yPercent: 100,
			rotationX: 20,
			opacity: 0,
			stagger: 0.05, // intervalle entre les lettres
			ease: "circ.out",
			duration: 1,
			delay: i * 0.3, // intervalle entre les lignes
		});
	});

	// Ligne verticale
	gsap.to(".is-border-right", {
		height: "100%",
		duration: 1,
		ease: "power2.out",
		delay: 0.2,
	});
	gsap.to(".is-border-top", {
		width: "100%",
		duration: 1,
		ease: "power2.out",
		delay: 0.2,
	});

	gsap.to(".is-border-bottom", {
		width: "100%",
		duration: 1,
		ease: "power2.out",
		delay: 0.2,
	});
};

const splitTextAnimations = () => {
	const animated_texts = document.querySelectorAll('[data-gsap="animate-title"]');
	animated_texts.forEach((el) => {
		const split = new SplitText(el, {
			type: "chars,words,lines",
			linesClass: "line",
			charsClass: "char",
			mask: "lines",
		});
		split.lines.forEach((line, i) => {
			gsap.from(line.querySelectorAll(".char"), {
				yPercent: 100,
				rotationX: 20,
				alpha: 0,
				stagger: 0.01,
				ease: "expo.out",
				duration: 1,
				delay: i * 0.2,
				scrollTrigger: {
					trigger: el.closest(".section"),
					start: "top 50%",
					end: "bottom 70%",
					scrub: 1,
				},
			});
		});
	});

	let split, tl;
	const createSplit = () => {
		split && split.revert();
		tl && tl.revert();
		split = new SplitText('[data-gsap="animate-text"]', { type: "words" });
		tl = gsap
			.timeline({
				scrollTrigger: {
					trigger: "#intro",
					start: "top 50%",
					end: "bottom 50%",
					scrub: 1,
				},
			})
			.set(split.words, { opacity: 0.2 })
			.to(split.words, {
				opacity: 1,
				stagger: 0.1,
				ease: "power2.out",
			});
	};
	createSplit();
	gsap.delayedCall(0.2, createSplit).pause();
	window.addEventListener("resize", () => gsap.delayedCall(0.2, createSplit).restart(true));
};

const miscAnimations = (mm) => {
	mm.add("(min-width: 800px)", () => {
		gsap.utils.toArray(".key-figures__item").forEach((figure, index) => {
			gsap.from(figure, {
				y: 150 + index * 100,
				alpha: 0,
				duration: 3,
				ease: "linear",
				scrollTrigger: {
					trigger: figure.closest(".section"),
					start: "top 50%",
					end: "bottom 50%",
					scrub: 2,
				},
			});
		});
	});

	gsap.utils.toArray('[data-gsap="animate-elt"]').forEach((elt) => {
		gsap.from(elt, {
			y: 30,
			alpha: 0,
			ease: "linear",
			scrollTrigger: {
				trigger: elt,
				start: "top 50%",
				end: "bottom 50%",
				scrub: 1,
			},
		});
	});

	gsap.utils.toArray(".our-teams__item").forEach((item, index) => {
		gsap.from(item, {
			y: 100 + index * 20,
			alpha: 0,
			duration: 3,
			ease: "linear",
			scrollTrigger: {
				trigger: item.closest(".section"),
				start: "top 50%",
				end: "70% 50%",
				scrub: 2,
			},
		});
	});
};

// -------------------------------
// SPLASH SCREEN + INIT
// -------------------------------
window.addEventListener("load", () => {
	const loader = document.getElementById("loader");
	const circles = document.querySelectorAll(".splash-screen-circle");

	document.body.classList.add("is-loading");

	const isMobile = window.innerWidth < 768;

	// Animation des cercles
	circles.forEach((circle, i) => {
		const tl = gsap.timeline();

		tl.to(circle, {
			width: isMobile
				? `${(i + 1) * 45}dvw` // plus petit sur mobile
				: `${(i + 1) * 50}dvh`,
			duration: 1.2,
			ease: "power2.out",
			delay: i * 0.1, // décalage léger
			alpha: 0.5,
		})
			.to(
				".splash-logo-1",
				{
					scale: 1,
					rotation: 360,
					alpha: 1,
					duration: 0.6,
				},
				"<"
			)
			.to(
				".splash-logo-2",
				{
					alpha: 1,
					duration: 0.4,
					stagger: 0.075,
				},

				"<"
			)

			.to(
				circle,
				{
					duration: 2.5,
				},
				"<"
			)

			.to(circle, {
				width: 0,
				duration: 0.6,
				ease: "power2.in",
				alpha: 0,
			})
			.to(
				".splash-logo-2",
				{
					alpha: 0,
					duration: 0.4,
					scale: 0,
				},
				"<"
			)
			.to(
				".splash-logo-1",
				{
					scale: 0,
					rotation: -360,
					alpha: 0,
					duration: 0.6,
				},
				"<"
			);

		tl.to(
			".splash-screen-circle-end",
			{
				duration: 0.6,
				ease: "power2.inOut",
				scale: 0,
				alpha: 0,
			},
			"<"
		);
	});

	// Timeout pour laisser le splash visible
	setTimeout(() => {
		if (loader) loader.classList.add("is-hidden");
		document.body.classList.remove("is-loading");

		// Création du smoother et lancement des animations principales
		const smoother = ScrollSmoother.create({ smooth: 2, effects: true });

		introAnimations();
		splitTextAnimations();
		miscAnimations(gsap.matchMedia());

		ScrollTrigger.refresh();

		document.querySelectorAll("[data-anchor]").forEach((anchor) => {
			anchor.addEventListener("click", () => {
				const targetSelector = anchor.getAttribute("data-anchor");
				const target = document.querySelector(targetSelector);
				const header = document.querySelector(".header");
				const headerHeight = header ? header.offsetHeight : 0;

				const y = ScrollSmoother.get().offset(target);
				ScrollSmoother.get().scrollTo(y - headerHeight, true);

				const burger = document.querySelector(".burger");
				if (burger && BurgerMenu.closeBurger) {
					BurgerMenu.closeBurger(burger, {});
				}
			});
		});

		CountUp.init({
			selector: ".key-figures__number",
			once: false,
			threshold: 0.8,
			easing: "linear",
		});
	}, 3500); // <- Ajuste selon la durée totale de ton splash
});
